module.exports = __webpack_public_path__ + "img/wallet-active.24a94693.svg";